import { jsPDF } from "jspdf";
import JsBarcode from "jsbarcode";
import { createCanvas } from "canvas";
import QRcode from 'qrcode';

import logo from '../assets/pdf/LogoGobierno_21_27_test_2.png'
import EBGaramond from '../assets/fonts/EBGaramond-Regular.ttf'
import EBGaramondBold from '../assets/fonts/EBGaramond-Bold.ttf'
import { bancos } from "../helpers/dataBancos";

import bbva from 'assets/img/bancos/BBVA_Bancomer_logo.svg.png';
import sant from 'assets/img/bancos/Santander_Logotipo.svg.png';
import banm from 'assets/img/bancos/banamex.png';
import hsbc from 'assets/img/bancos/HSBC.svg.png';
import scot from 'assets/img/bancos/scotiabank.png';
import afir from 'assets/img/bancos/afirme.png';
import tele from 'assets/img/bancos/telecomm.png';
import azte from 'assets/img/bancos/banco-azteca.png';
import banor from 'assets/img/bancos/BANORTE.png';
import EasyPdf from "utils/easyPdf";


const { santander } = bancos;
const FONTSIZE = 8;
const FONTSIZETITLE = 10;
let doc = new jsPDF();
const init = () => {
    doc = new jsPDF();
}

const pageSizeWidth = doc.internal.pageSize.width;
const pageSizeHeight = doc.internal.pageSize.height;

let sdoc = new EasyPdf(15, 10, { instanceDoc: doc });

export async function createPDF({ datosRecibo, arCuentas, referencia }, ref, isAyuntamiento = false) {
    init();
    const initial = 15;
    const initRef = ref.substr(0, 3);
    const isCart = initRef === '005';
    let yBase = 75;

    sdoc = new EasyPdf(initial, 10, { instanceDoc: doc });

    doc.addFont(EBGaramond, 'garamound', 'normal');
    doc.addFont(EBGaramondBold, 'garamound', 'bold');
    doc.setFont('garamound');
    doc.setFontSize(12);

    const dataDate = referencia.fechaLimite.split('-');
    const dia = dataDate[2].substr(0, 2);
    const mes = dataDate[1];
    const año = dataDate[0].substr(-2, 2);


    if (initRef !== '005') {
        titleWithLine('DATOS DEL CONTRIBUYENTE', initial, yBase, pageSizeWidth);
        yBase += 7
        listTextwithBold([
            'RFC:' + datosRecibo.rfc,
            'NOMBRE DE SOLICITANTE:' + datosRecibo.contribuyentes,
        ], initial + 2, yBase);
        yBase += 10
    }

    const canvas = new createCanvas(10, 20);
    JsBarcode(canvas, ref);
    const barcode = canvas.toDataURL('image/png', 1.0);
    const width = canvas.width * 0.204583;
    const height = canvas.height * 0.154583;

    const imgBarcode = await loadImage(barcode);
    doc.addImage(imgBarcode, 'PNG', initial + 108, initRef !== '005' ? 105 : 87, width, height, 'barcode', 'FAST',);

    if (initRef !== '005') yBase += 25

    console.log('fuentes de ingreso = ', arCuentas);

    const isZofemat = arCuentas.some(
        e => e.cuentas?.some(
            c =>c.clvFuenteIngreso.trim() === '58443' || c.clvFuenteIngreso.trim() === '99618' || c.clvFuenteIngreso.trim() === '99617' 
        ));
    
    let cuentas =  Array.from(arCuentas, v => ({
        cuenta: v.clvFuenteIngreso,
        descripcion: v.descripcion,
        importe: v.importe,
        cantidad: v.cantidad,
        total: v.importeTotal
    }));

    if (initRef === '005') {
        cuentas = arCuentas;
    }
    
    printTotal(referencia.importe, 230);
    doc.setFontSize(7);
    doc.text(referencia.importe_en_Letra??'', pageSizeWidth - 75, 233)
    doc.setFontSize(FONTSIZE);
    const numExtraInY = payData(datosRecibo, referencia, isCart, initRef, ref);
    isCart
        ? detailCart(initial, 110, arCuentas, referencia.importe)
        : simpleTable(initial, (initRef !== '005' ? 140 : 115)+(numExtraInY-3), cuentas, referencia.importe)
    ;

    let claveHojaMillar = '';
    const isHojaMillar = arCuentas.filter(e => e.cuentas?.filter(c => {
        if (c.clvFuenteIngreso.trim() === '58444' || c.clvFuenteIngreso.trim() === '58461') {
          claveHojaMillar = c.clvFuenteIngreso;
          return true;
        }
        return false;
      }).length > 0).length > 0;

    if (isHojaMillar) {
        claveHojaMillar = claveHojaMillar === '58444' ? santander.convenio3 : santander.convenio4
    }

    const numPages = doc.getNumberOfPages()
    for (let i = 0; i < numPages; i++) {
        const page = i+1;
        doc.setPage(page)
        await header(referencia, initRef);

        setFolio(referencia.folio, dia, mes, año, true);
        
        printTotal(referencia.importe, 230);
        await footer(ref, isAyuntamiento, datosRecibo.zonaHospedaje, numPages, page, {isHojaMillar, claveHojaMillar}, isZofemat, arCuentas);
    }

    const tenencia = cuentas.find(c => (c.serie?.trim()??'') !== '');
    tenencia && pageAvisoTenencia();

    doc.autoPrint({ variant: 'non-conform' });
    window.open(doc.output('bloburl', { filename: 'my.pdf' }));
    doc.close();
}

const payData = ( datosRecibo, referencia, isCart, initRef, ref ) => {
    const initial = 15;
    doc.setFontSize(FONTSIZE);
    titleWithLine(
        'DATOS DE PAGO',
        initial,  isCart ? 75 : 97, pageSizeWidth
    );

    doc.setFontSize(FONTSIZETITLE);

    if (initRef !== '085') {
        textWithBold('Ejercicio:', `${datosRecibo.ejercicio}`, initial + 110, 75);
        !isCart && textWithBold('Periodo:', `${datosRecibo.periodo ?? ''}`, initial + 135, 75);
    }
    doc.setFontSize(FONTSIZE);

    doc.setFontSize(FONTSIZE);
    const date = new Date();
    const tipoDeclaracion = datosRecibo.tipoDeclaracion === 'N' ? 'NORMAL' : 'COMPLEMENTARIA';
    const data = [
        'FECHA ACTUAL:' + date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate(),
        'REFERENCIA DE PAGO:' + ref,
        'FECHA LIMITE DE PAGO:' + referencia.fechaLimite,
    ].concat(
        !isCart ?
            [
                'TIPO DE DECLARACIÓN:' + tipoDeclaracion,
                'BASE GRABABLE:' + datosRecibo.BaseGravable,
                'No. EMPLEADOS:' + datosRecibo.NoEmpleados
            ] : []
    );

    listTextwithBold(data, initial + 10, !isCart ? 105 : 85);

    let spaceExtraInY = 5;
    if(!isCart && typeof datosRecibo.concepto !== 'undefined' && datosRecibo.concepto !== ''){
        const numOfLines = listTextwithBold(['DESCRIPCIÓN:'+datosRecibo.concepto], initial + 10, 135);
        spaceExtraInY *= numOfLines;
    }
    return spaceExtraInY;
 }

const textWithBold = (text, textBold, x, y) => {
    doc.text(text, x, y);
    const extra = getSizeTextInX(text) + x;
    doc.setFont('garamound', 'bold');
    doc.text(textBold, extra, y);
    doc.setFont('garamound', 'normal');
}

const header = async (referencia, initRef) => {
    const imgLogo = await loadImage(logo);

    doc.addImage(imgLogo, 'JPG', 15, 15, 50, 20, 'logo', 'FAST');
    doc.setTextColor('#517ea8');
    doc.text('SECRETARÍA DE FINANZAS Y ADMINISTRACIÓN SUBSECRETARÍA DE INGRESOS', pageSizeWidth * 0.70, 25, { align: 'center', maxWidth: 100 });
    doc.setTextColor('black');

    doc.setFontSize(15);
    doc.text('Hoja de pago referenciado', pageSizeWidth / 2, 50, { align: 'center', maxWidth: pageSizeWidth - 10 });
    doc.setFontSize(FONTSIZE);

    doc.setFontSize(FONTSIZETITLE);
    doc.setFont('garamound', 'bold');
    doc.text(initRef === '005' ? 'IMPUESTO Y DERECHOS ESTATALES' : referencia.descripcionImpuesto, 15, 65, { maxWidth: 110 });
    doc.setFont('garamound', 'normal');
    doc.setFontSize(FONTSIZE);
}

const setFolio = (folio, dia, mes, año) => {
    doc.rect(pageSizeWidth - 75, 60, 60, 8);
    doc.setFontSize(FONTSIZETITLE);
    doc.text('Folio:', pageSizeWidth - 65, 60 + 5, { align: 'center', maxWidth: 100 });
    doc.setFont('garamound', 'bold');
    doc.text('' + folio + ' -  ' + dia + mes + año, pageSizeWidth - 40, 60 + 5, { align: 'center', maxWidth: 100 });
    doc.setFont('garamound', 'normal');
    doc.setFontSize(FONTSIZE);
}

const listTextwithBold = (listText, x, y, saltoLinea = true) => {
    let maxText = ''
    let maxTextBold = '';
    listText.forEach(v => {
        const [text1, textBold] = v.split(':');
        maxText = text1.length > maxText.length ? text1 : maxText;
        maxTextBold = textBold.length > maxTextBold.length ? textBold : maxTextBold;
    });

    const fontSize = doc.getFontSize();
    const xbold = doc.getStringUnitWidth(maxText) * fontSize / (72 / 25.6) + x + 2;
    const sizeBold = doc.getStringUnitWidth(maxTextBold) * fontSize / (72 / 25.6) + x + 2;
    
    const totalLines = sizeBold / 150;
    
    let ny = y;
    for (const text of listText) {
        const text1 = text.split(':')[0];
        doc.text(text1 + ':', x, ny);
        ny += 5;
    }

    let by = y;
    doc.setFont('garamound', 'bold');
    listText.forEach(v => {
        const bold = v.split(':')[1];
        doc.text(bold, xbold, by, saltoLinea ? {maxWidth:150} : {});
        by += 5
    })
    doc.setFont('garamound', 'normal');
    return totalLines;
}

const simpleTable = (x, y, cuentas, total) => {
    const numFilas = 10;
    let ySpace = y;

    let newPage = cuentas.length > numFilas;

    let positions = printTitleCuentas(x, ySpace);

    const reduceDecimals = (number) => {
        const [valor, decimales] = number.split('.');
        return valor + '.' + decimales.slice(0, 2);
    }

    doc.setFontSize(FONTSIZE);
    ySpace = ySpace + 7;
    cuentas.forEach((v, i) => {
        if (i > numFilas && newPage) {
            doc.addPage();
            ySpace = 50;
            positions = printTitleCuentas(x, ySpace);
            ySpace += 7;
            newPage = false;
        }
        doc.text(v.cuenta??'', x, ySpace);
        doc.text(v.descripcion??'', positions[0], ySpace, { maxWidth: positions[2] - positions[0] });
        doc.text(reduceDecimals(v.total??'0.0'), positions[2] + 5, ySpace);
        ySpace += 7;
    })

    if (cuentas.length > numFilas) {
        printTotal(total, ySpace);
    }

}

const detailCart = (x, y, cuentas) => {
    let xSpace = x;
    let ySpace = y;
    
    sdoc.text('DETALLE DE CUENTA', { x: xSpace, y: ySpace, bold: true });

    doc.setFontSize(FONTSIZE);
    ySpace = ySpace + 5;
    xSpace += 5
    
    const reduceDecimals = (number) => {
        let totalWithFormat = parseFloat(number).toLocaleString('en-US', { minimumFractionDigits: 2 });

        totalWithFormat += '';
        return totalWithFormat;
    }

    const limiteImpresion = 225;

    cuentas.forEach((v) => {
        let calY = ySpace + 10 + 12;
        if (calY > limiteImpresion) {
            doc.addPage();
            ySpace = 75;
        }
        sdoc.text(v.modulo, { x: xSpace, y: ySpace, bold: true });
        ySpace += 5;
        if (v.serie) {
            sdoc.textWithBold('serie:', v.serie, xSpace, ySpace, { bold: true });
        }
        sdoc.textWithBold('nombre:', v.nombre, v.serie ? xSpace + 40 : xSpace, ySpace, { bold: true });
        ySpace += 5;
        if (v.concepto) {
            const numOfLines = parseInt(v.concepto.length / 95) ;
            sdoc.textWithBold('concepto:', v.concepto??'', xSpace, ySpace, { bold: true, maxWidth: 165 });
            ySpace += numOfLines > 1 ? numOfLines * 5 : 8;
        }

        let positions = printTitleCuentas(xSpace, ySpace, ['Cuenta', 'Descripción', 'Ejercicio', 'Importe'], true);
        ySpace += 5;
        const maxWidthDesc = positions[1] - positions[0] - 3;
        v.cuentas.forEach(c => {
            if (ySpace > limiteImpresion) {
                doc.addPage();
                printTitleCuentas(xSpace, 110, ['Cuenta', 'Descripción', 'Ejercicio', 'Importe'], true);
                ySpace = 115;
            }
            doc.text(c.clvFuenteIngreso, xSpace, ySpace, { maxWidth: 70 });
            doc.text(c.descripcion, positions[0], ySpace, { maxWidth: maxWidthDesc });
            const noDuplicates = c.ejercicio.split(',').filter((v, index, array) => array.indexOf(v) === index).join(', ');
            
            doc.text(noDuplicates, positions[1], ySpace, { maxWidth: 15 });
            doc.text(reduceDecimals(c.importe), positions[2], ySpace, { maxWidth: 70 });
            ySpace += 7;
        });
    })
}

const printTitleCuentas = (x, y, titleColumns = ['CUENTA', 'DESCRIPCIÓN', 'TOTAL'], columnExtraSpace = false) => {
    const finalLine = pageSizeWidth - 25;

    const printSpace = finalLine - x;

    const columnSpacing = (printSpace / titleColumns.length) / 2;

    let positions = [];
    doc.setFont('garamound', 'bold');
    titleColumns.forEach((v, i) => {
        if (i === 1 && columnExtraSpace) {
            doc.text(v, x, y);
            x = x + printSpace - (columnSpacing * (titleColumns.length - 1));
            positions.push(x);
            return;
        }
        if (v === 'TOTAL' | v === 'IMPORTE') {
            const newX = finalLine - getSizeTextInX(v)
            doc.text(v, newX, y);
            positions.push(newX);
            return;
        }

        doc.text(v, x, y);
        x = columnSpacing + x;
        positions.push(x);
    })

    doc.setFont('garamound', 'normal');

    return positions;
}

const titleWithLine = (text, x, y, pageSizeWidth) => {
    doc.setFontSize(FONTSIZETITLE);
    doc.text(text, x, y);
    doc.line(x, y + 3, pageSizeWidth - 15, y + 3);
    doc.setFontSize(FONTSIZE);
}

const textBold = (text, x, y, options) => {
    if (options?.size) doc.setFontSize(options.size);
    doc.setFont('garamound', 'bold');
    doc.text(text, x, y);
    doc.setFont('garamound', 'normal');
    if (options?.size) doc.setFontSize(FONTSIZE);
}

const loadImages = async (list, convenios, initialx, initialy) => {
    const width = pageSizeWidth * 0.085;
    const height = pageSizeHeight * 0.025;

    let x = initialx;
    let y = initialy;

    let texty = y + height + 3;
    let lineText = [texty];

    for (let i = 0; i < list.length; i++) {
        const banc = list[i];

        const imageBanc = await loadImage(banc);
        doc.addImage(imageBanc, 'PNG', x, y, width, height, '' + i, 'FAST');

        if (convenios[i].length > 10) {
            doc.setFontSize(7);
        } else {
            doc.setFontSize(9);
        }

        doc.text(convenios[i], x + width / 2, texty, { align: 'center', maxWidth: width });

        x = x + width + 2;

        if (x >= 135) {
            x = initialx
            y = y + 15;
            texty = y + height + 3;
            if (i < convenios.length - 1) lineText.push(texty);
        }
    }

    for (let i = 0; i < lineText.length; i++) {
        doc.text('Nº DE CONVENIO:', initialx - 28, lineText[i]);
    }
}

const footer = async (ref, isAyuntamiento = false, hospedaje, numPages, page, hojaMillar, isZofemat = false, fuentes ) => { 
    const initial = 15;
    doc.line(initial, pageSizeHeight - 59, pageSizeWidth - 15, pageSizeHeight - 59);
    doc.text('PUEDE REALIZAR SU PAGO EN LAS SIGUIENTES INSTITUCIONES:', initial + 2, pageSizeHeight - 55)
    let bancos = {
        images: [bbva, bbva, banm, sant, hsbc, scot, afir, banor, azte, tele],
        convenios: ['1831704\n(Practicaja)','780820\n(Pago en linea)', 'SEFINA GRO WS PA:4817/01', '1257', '9081', '1207', '185112810', '44032', '10246', '']
    };

    if (ref && ref.startsWith('086')) {
        bancos = {
            images: [sant, sant],
            convenios: ['0007279', '0007381']
        };
    }
    else if (ref && ref.startsWith('003') && fuentes.find(f => (f.clvFuenteIngreso === '12606'))) {
        bancos = {
            images: [sant],
            convenios: ['CUENTA: 51500568016 \nCLAVE: 014260515005680160']
        };
    }
    else if (hospedaje !== '0' && hospedaje !== 'PARE') {
        const conveniosBBVA = ['1444905', '1444883', '1444891'];
        bancos = {
            images: [bbva],
            convenios: [conveniosBBVA[parseInt(hospedaje) - 1]]
        };
    }
    else if (isAyuntamiento) {
        bancos = {
            images: [sant],
            convenios: ['9226']
        };
    }
    else if (hojaMillar.isHojaMillar) {
        bancos = {
            images: [sant],
            convenios: [hojaMillar.claveHojaMillar]
        };
    } else if (isZofemat) {
        bancos = {
            images: [sant],
            convenios: ['Transferencia\nCuenta: 65507573359\nCLABE: 014260655075733596']
        };
    }
    await loadImages(
        bancos.images,
        bancos.convenios,
        initial + 30,
        pageSizeHeight - 50
    );

    const canvasQR = createCanvas();
    QRcode.toCanvas(
        canvasQR,
        'https://esefina.ingresos-guerrero.gob.mx/pasarela/?ref=' + ref,
        function (error) {
            if (error) console.error(error)
        }
    );

    const img = await loadImage(canvasQR.toDataURL());
    doc.addImage(
        img,
        'PNG',
        pageSizeWidth - 57,
        pageSizeHeight - 55,
        30,
        30,
        'qrcode',
        'FAST'
    );

    doc.text(`Pagina ${page} de ${numPages}`, pageSizeWidth - 57, pageSizeHeight - 60);

    doc.text('continue su pago en linea', pageSizeWidth - 59, pageSizeHeight - 54);
    isAyuntamiento && textWithBold(
        '** Si realiza su pago a través de un BANCO DISTINTO A SANTANDER ocupará la siguiente cuenta CLABE:',
        '014260655057066498',
        initial + 2,
        pageSizeHeight - 23
    );
    
    hojaMillar.isHojaMillar && textWithBold(
        '** Si realiza su pago a través de un BANCO DISTINTO A SANTANDER ocupará la siguiente cuenta CLABE:',
        hojaMillar.claveHojaMillar === '0007279' ? '014260655054786399' : '014260655065785606',
        initial + 2,
        pageSizeHeight - 23
    );

    doc.line(initial, pageSizeHeight - 20, pageSizeWidth - 15, pageSizeHeight - 20);
    doc.text(
        'ESTA HOJA NO ES UN COMPROBANTE OFICIAL DE PAGO, POR LO QUE NO SERÁ SELLADO POR EL CAJERO',
        pageSizeWidth / 2, pageSizeHeight - 15, { align: 'center', maxWidth: pageSizeWidth - 30 });
}

const printTotal = (total, y) => {
    doc.setFontSize(11)
    let totalWithFormat = parseFloat(total).toLocaleString('en-US', { minimumFractionDigits: 2 });

    totalWithFormat += '';
    const xbold = getSizeTextInX('Total a pagar:'+ totalWithFormat);
    textWithBold('Total a pagar:', `$${totalWithFormat}`, pageSizeWidth - 30 - xbold - 2, y);
}

const getSizeTextInX = (text) => {
    const fontSize = doc.getFontSize();
    const size = doc.getStringUnitWidth(text) * fontSize / (72 / 25.6) + 2;
    return size;
}

const loadImage = (src) => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = src;
        img.onload = () => resolve(img);
        img.onerror = reject;
    })

}

const pageAvisoTenencia = () => {
    const year = new Date().getFullYear();
    doc.addPage();

    // Header
    doc.setFont('garamound', 'bold');
    doc.setFontSize(12);
    doc.text(`REQUISITOS PARA CANJEAR RECIBO OFICIAL ${year}`, pageSizeWidth / 2, 20, { align: 'center' });

    // Intro paragraph
    doc.setFontSize(9);
    doc.setFont('garamound', 'normal');
    textWithMixedStyles(doc, 15, 32, [
        { text: 'Estimado contribuyente: ', bold: true },
        { text: 'Para obtener tu ', bold: false },
        { text: 'recibo oficial, tarjeta de circulación', bold: true },
        { text: ' y, en su caso, realizar el ', bold: false },
        { text: `canje de placas ${year}`, bold: true },
        { text: ', deberás presentar la documentación correspondiente en ', bold: false },
        { text: `cualquier Oficina Fiscal del Estado, antes del 31 de diciembre de ${year}.`, bold: true }
    ]);

    // Consideraciones generales (título)
    doc.setFont('garamound', 'bold');
    doc.setFontSize(10);
    doc.text('CONSIDERACIONES GENERALES', 15, 45);
    doc.setFont('garamound', 'normal');
    doc.setFontSize(9);

    // Bulleted list with possible sub-bullets
    let ny = 50;
    const printBullet = (textFN, indent = 18, maxW = pageSizeWidth - 40) => {
        doc.text('\u2022', indent, ny);
        textFN(indent + 6, ny);
        ny += 7;
    };
    const printSubBullet = (textFn, indent = 24, maxW = pageSizeWidth - 50) => {
        doc.text('o', indent, ny);
        textFn(indent + 6, ny);
        ny += 6.5;
    };

    printBullet((x,y) => textWithMixedStyles(doc, x, y, [
        { text: 'El ', bold: false },
        { text: 'canje de placas ', bold: true },
        { text: 'es obligatorio cada ', bold: false },
        { text: 'tres años.', bold: true },
    ]));
    printBullet((x,y) => doc.text('Durante el año inmediato anterior se llevó a cabo el canje general de placas; sin embargo:', x, y));
    printSubBullet((x,y) => textWithMixedStyles(doc, x, y, [
        { text: 'Algunos vehículos ', bold: false },
        { text: 'no realizaron el canje.', bold: true }
    ]));
    printSubBullet((x,y) => textWithMixedStyles(doc, x, y, [
        { text: 'En estos casos, al no contar con ', bold: false },
        { text: 'recibo oficial ni tarjeta de circulación ', bold: true }, 
        { text: '(documentos que se emiten de manera conjunta), deberán ', bold: false },
        { text: 'acreditar su situación conforme a los requisitos establecidos para vehículos con adeudos.', bold: true }
    ]));

    // Sección A
    ny += 4;
    doc.setFont('garamound', 'bold');
    doc.text('A) VEHÍCULOS AL CORRIENTE EN SUS PAGOS', 15, ny);
    ny += 7;
    doc.setFont('garamound', 'normal');
    doc.text('Requisitos:', 15, ny);
    ny += 6;

    const requisitosA = [
        (x,y) => textWithMixedStyles(doc, x, y, [
            { text: 'Tarjeta de circulación ', bold: false },
            { text: `${year - 1} `, bold: true },
            { text: 'o recibo oficial de pago ', bold: false },
            { text: `${year - 1} `, bold: true },
        ]),
        (x,y) => textWithMixedStyles(doc, x, y, [
            { text: 'Identificación oficial vigente (INE) del propietario, ', bold: false },
            { text: 'ampliada al 200%.', bold: true },
        ]),
        (x, y) => textBold( 'Comprobante de pago de Tenencia 2026.', x, y )
    ];
    requisitosA.forEach(r => printBullet((x,y) => r(x, y), 18));
    ny += 2;
    doc.setFont('garamound', 'bold');
    doc.text('Recomendación:', 15, ny);
    doc.setFont('garamound', 'normal');
    const rec = 'Realiza tu pago en línea y evita filas. https://esefina.ingresos-guerrero.gob.mx/Tenencia/ModuloExterno/';
    doc.text(rec, 38, ny, { maxWidth: pageSizeWidth - 60 });
    ny += 10;

    // Sección B
    doc.setFont('garamound', 'bold');
    doc.text('B) VEHÍCULOS CON ADEUDOS 2025 Y ANTERIORES', 15, ny);
    ny += 7;
    doc.setFont('garamound', 'normal');
    doc.text('Requisitos:', 15, ny);
    ny += 6;

    const requisitosB = [
        (x,y) => textWithMixedStyles(doc, x, y, [
            { text: 'Formulario SFA-01 ', bold: true },
            { text: 'debidamente requisitado.', bold: false },
        ]),
        (x,y) => textWithMixedStyles(doc, x, y, [
            { text: 'Factura del vehículo ', bold: true },
            { text: '(original y copia).', bold: false },
        ]),
        (x, y) => textWithMixedStyles(doc, x, y, [
            { text: 'Identificación oficial vigente (INE) ', bold: false },
            { text: 'al 200% ', bold: true },
            { text: 'del propietario y del vendedor, en su caso.', bold: false },
        ]),
        (x, y) => textWithMixedStyles(doc, x, y, [
            { text: 'CURP ', bold: true },
            { text: 'del propietario.', bold: false },
        ]),
        (x, y) => textWithMixedStyles(doc, x, y, [
            { text: 'Recibos de pago de los últimos 5 años ', bold: true },
            { text: '(dependiendo del modelo del vehículo).', bold: false },
        ]),
        (x, y) => textBold('Calca, fotografía o copia del número de serie del vehículo.', x, y),
        (x, y) => textWithMixedStyles(doc, x, y, [
            { text: 'Comprobante de domicilio vigente ', bold: true },
            { text: '(no mayor a 3 meses).', bold: false },
        ]),
        (x, y) => textWithMixedStyles(doc, x, y, [
            { text: 'Constancia de Inscripción Vehicular REPUVE. ', bold: true },
            { text: 'Descárgala desde https://www2.repuve.gob.mx:8443/ciudadania/', bold: false },
        ])
    ];
    requisitosB.forEach(r => printBullet((x,y) => r(x, y), 18));

    // Representación y notas finales (manteniendo estilo similar a imagen)
    doc.setFont('garamound', 'bold');
    doc.text('REPRESENTACIÓN:', 15, ny);
    ny += 6;
    printBullet((x,y) => textBold('Persona física:', x, y));
    printSubBullet((x,y) => doc.text('Carta poder simple con copia del INE del propietario y apoderado.', x, y));
    // ny += 6;
    printBullet((x,y) => textBold('Persona moral:', x, y));
    printSubBullet((x,y) => doc.text('Escritura pública o carta poder firmada por dos testigos, con firmas ratificadas ante la autoridad fiscal.', x, y));

    doc.setFont('garamound', 'bold');
    doc.text('NOTAS IMPORTANTES:', 15, ny);
    ny += 6;
    printBullet((x,y) => textWithMixedStyles(doc, x, y, [
        { text: 'presentar ', bold: false },
        { text: 'original y copia', bold: true },
        { text: ' de toda la documentación.', bold: false },
    ]));
    printBullet((x,y) => textWithMixedStyles(doc, x, y, [
        { text: '✔️ En caso de acudir a una Oficina Fiscal distinta a la habitual, ', bold: true },
        { text: 'será indispensable presentar ', bold: false },
        { text: 'la totalidad de la documentación requerida, ', bold: true },
        { text: 'incluyendo los ', bold: false },
        { text: 'recibos de pago correspondientes ', bold: true },
        { text: ', según el modelo del vehículo.', bold: false },
    ]));

    ny += 15;
    // final document
    textWithMixedStyles(doc, 15, ny, [
        { text: 'Fundamento legal: ', bold: true },
        { text: 'Publicados en el Periódico Oficial del Gobierno del Estado de Guerrero, Número 64, Alcance IV, de fecha ', bold: false },
        { text: '09 de agosto de 2024.', bold: true },
    ]);
    
    ny += 10;
    // Para más información, comunícate al 800 907 33 46.
    textWithMixedStyles(doc, 15, ny, [
        { text: 'Para más información, comunícate al ', bold: false },
        { text: '800 907 33 46.', bold: true },
    ]);

}

function textWithMixedStyles(doc, x, y, fragments, options = {}) {
    const fontFamily = options.fontFamily || 'garamound';
    const fontSize = doc.getFontSize();
    const maxWidth = options.maxWidth || (doc.internal.pageSize.width - x - 15);
    let currentX = x;
    let currentY = y;

    fragments.forEach(({ text, bold }) => {
        doc.setFont(fontFamily, bold ? 'bold' : 'normal');
        let words = text.split(' ');
        let line = '';

        for (let i = 0; i < words.length; i++) {
            let testLine = line + (line ? ' ' : '') + words[i];
            let testWidth = doc.getStringUnitWidth(testLine) * fontSize / (72 / 25.6);

            if (currentX + testWidth > x + maxWidth && line) {
                // Print current line and move to next
                doc.text(line, currentX, currentY);
                currentY += fontSize * 0.35 + 2; // Ajusta el salto de línea según tu diseño
                line = words[i];
                currentX = x;
            } else {
                line = testLine;
            }
        }
        // Print last line of this fragment
        if (line) {
            doc.text(line, currentX, currentY);
            // Avanza X para el siguiente fragmento
            let width = doc.getStringUnitWidth(line) * fontSize / (72 / 25.6);
            currentX += width;
        }
    });
    doc.setFont(fontFamily, 'normal');
}
